import React, { useCallback, useEffect, useRef, useState } from 'react'

import { IoPersonOutline, IoLogOutOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router'

import AdminHeader from './AdminHeader'
import StudentHeader from './StudentHeader'
import {
  HeaderContainer,
  HeaderRow,
  HeaderTitle,
  HeaderNotificationsContainer,
  HeaderProfile,
  ProfileContainer,
} from './styled'
import { HeaderNotification } from '..'
import { useUser } from '../../context'
import { HeaderProps } from '../../types'
// import ToggleSwitch from '../ToggleSwitch'
import { Spacer } from '../global'
import { SectionSubtitle } from '../texts'

const Header = ({
  title,
  // profileImage,

  // setClassToggle,
}: HeaderProps) => {
  const navigate = useNavigate()
  // const location = useLocation()
  const { signOut, user, userRole } = useUser()

  const [profileOptions, setProfileOptions] = useState(false)
  const profileOptionRef = useRef<HTMLDivElement | null>(null)

  const toggle = useCallback(() => setProfileOptions((v) => !v), [])

  const handleEditProfileClick = () => {
    navigate('/perfil', { state: { isEditMode: false } })
  }

  const dashboardTitle =
    title === 'admin'
      ? 'Administración'
      : title === 'professor'
        ? 'Sala de profesores'
        : `Hola ${user?.name}!`

  const handleLogout = () => {
    console.log('here')
    signOut()
    navigate('/')
  }

  const handleOpenChallenge = (challengeId: string) => {
    console.log(challengeId, 'cha')
    navigate('/desafios')
  }

  // cerrar al click afuera
  useEffect(() => {
    if (!profileOptions) return

    const onClick = (e: MouseEvent) => {
      if (!profileOptionRef.current) return
      if (!profileOptionRef.current.contains(e.target as Node))
        setProfileOptions(false)
    }

    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [profileOptions])

  return (
    <HeaderContainer>
      <HeaderRow>
        <HeaderNotificationsContainer $userRole={userRole}>
          {/* {userRole === 'student' && location.pathname !== '/initial-form' && (
            <ToggleSwitch setToggle={setClassToggle} />
          )} */}
          <HeaderNotification
            pageSize={10}
            onOpenChallenge={handleOpenChallenge}
          />

          <div ref={profileOptionRef}>
            <HeaderProfile
              style={{
                backgroundImage: user?.image
                  ? `url(${user?.image})`
                  : `url('/assets/profile.png')`,
              }}
              onClick={toggle}
            />

            {profileOptions && (
              <ProfileContainer>
                <div className="list">
                  <div onClick={handleEditProfileClick}>
                    <IoPersonOutline /> Perfil
                  </div>
                  <div onClick={handleLogout}>
                    <IoLogOutOutline /> Cerrar Sesión
                  </div>
                </div>
              </ProfileContainer>
            )}
          </div>
        </HeaderNotificationsContainer>
        <HeaderTitle $userRole={userRole}>
          <p>{dashboardTitle}</p>
          {userRole === 'student' && (
            <SectionSubtitle
              fontSize={16}
              fontWeight={500}
              classSub="student-subheader"
            >
              Nos preparamos para cantar?
            </SectionSubtitle>
          )}
        </HeaderTitle>
      </HeaderRow>
      {userRole === 'student' && (
        <>
          <Spacer height={16} />
          <StudentHeader />
        </>
      )}
      {/* {userRole !== 'student' && <Spacer height={60} />} */}
      {userRole === 'admin' && <AdminHeader />}
    </HeaderContainer>
  )
}

export default Header
